
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class AepsPopupComponent extends Vue {
  @Prop() public data;

  resetForm() {
    this.$emit("cancel", true);
  }

  offerAmount(value){
    this.$emit("cancel", true);
    this.$emit("rechargeOfferAmount",value);
  }

}
